var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"r-footer"},[_c('small',{staticClass:"r-footer--small"},[_vm._v("©"+_vm._s(_vm.year)+" recipro")])])
}
var staticRenderFns = []

export { render, staticRenderFns }